import { render, staticRenderFns } from "./ApplicantSeedTabs.vue?vue&type=template&id=460713dd&"
import script from "./ApplicantSeedTabs.vue?vue&type=script&lang=js&"
export * from "./ApplicantSeedTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports